<template>
  <dialog-form
    :show-dialog="isShowDialog"
    :loading="loading"
    :is-disabled="!reason.trim()"
    @open="dialogOpen"
    @cancel="emit('cancel')"
    @submit="emit('submit', reason.trim())"
  >
    <template #title>
      Raise dispute
    </template>

    <p class="text-muted">
      A supervisor will decide whether the AI got this call wrong. You can only raise one dispute per calibration.
    </p>

    <div class="row align-items-center">
      <label class="col-sm-3 control-label">Reason*</label>
      <div class="col-sm-9">
        <sanitized-textarea
          v-model="reason"
          allow-unicode
          :maxlength="MAX_TEXT_LENGTH"
          rows="4"
        />
      </div>
    </div>

    <template #submit-button>
      Raise dispute
    </template>
  </dialog-form>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { MAX_TEXT_LENGTH } from './qaCalibrations';

defineProps({
  isShowDialog: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  (e: 'submit', reason: string): void;
  (e: 'cancel'): void;
}>();

const reason = ref('');

const dialogOpen = () => {
  reason.value = '';
};
</script>
